import rolesApi from '../../api/roles'

export default {
  namespaced: true,
  state: {
    listPage: null
  },
  getters: {
  },
  mutations: {
    setListPage(state, page) {
      state.listPage = page
    }
  },
  actions: {
    searchRoles(context, request) {
      return rolesApi.search(request).then(function (response) {
        context.commit('setListPage', response.data)
      });
    }
  },
  modules: {
  }
}